import { useEffect, useState } from "react";

export default function useWindowResize() {
  const [screenSize, setScreenSize] = useState({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  });
  const setDimension = () => {
    setScreenSize({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return {
    windowWidth: screenSize.windowWidth,
    windowHeight: screenSize.windowHeight,
  };
}
